import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private _theme = new BehaviorSubject<'light' | 'dark'>('light');
  currentTheme$ = this._theme.asObservable();

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setTheme(theme: 'light' | 'dark'): void {
    const host = this.document.body;
    this.renderer.removeClass(host, 'theme-light');
    this.renderer.removeClass(host, 'theme-dark');
    this.renderer.addClass(host, `theme-${theme}`);
    this._theme.next(theme); // Emit the new theme
  }
}